var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_2643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6411 0.75H15.0936L9.7088 6.90316L16 15.25H11.063L7.1976 10.1777L2.77241 15.25H0.319896L6.02466 8.66885L0 0.75H5.05965L8.55184 5.38358L12.6411 0.75ZM11.7827 13.8053H13.1423L4.34522 2.14115H2.88437L11.7827 13.8053Z",
    fill: "#B5B7BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_2643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactTwitter);
export default __webpack_public_path__ + "static/media/contact_twitter.01ea8c05f8088ce77d4c4d758c22e6d3.svg";
export { ForwardRef as ReactComponent };